import Axios from "@/plugins/Axios";

export class PlanosSemestraisService {
  async planoSemestral(gestaoDeAulaId, semestre, disciplinaId) {
    const response = await Axios().get(
      `planos-semestrais/plano-semestral/${gestaoDeAulaId}/${semestre}/${disciplinaId}`
    );
    return response.data;
  }

  async pegarPlanos(gestaoDeAulaId, disciplinaId) {
    const response = await Axios().get(
      `planos-semestrais/pegar-planos/${gestaoDeAulaId}/${disciplinaId}`
    );
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-semestrais/criar-plano-semestral`, {
      plano,
    });
    return response.data;
  }

  async salvarPlanos(planos, gestaoDeAulaId, disciplinaId) {
    const response = await Axios().post(
      `planos-semestrais/salvar-planos/${gestaoDeAulaId}/${disciplinaId}`,
      {
        planos,
      }
    );
    return response.data;
  }

  async planoSemestralPDF(gestaoDeAulaId, semestre, disciplinaId, file) {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await Axios().post(
        `planos-semestrais/uploadPdf/${gestaoDeAulaId}/${semestre}/${disciplinaId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const resultData = response.data ?? response;
      if (resultData) {
        return resultData;
      }
      // console.warn("Upload bem-sucedido, mas sem resposta significativa do servidor.");
      return null;
    } catch (error) {
      // console.error("Erro ao enviar o arquivo:", error);
      // throw error;
    }
  }

  async planoSemestralDownload(gestaoDeAulaId, semestre, disciplinaId) {
    const response = await Axios()
      .get(`planos-semestrais/downloadPdf/${gestaoDeAulaId}/${semestre}/${disciplinaId}`, {
        responseType: "blob",
      })
      .then((response) => {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(response.data);
        window.open(a.href);
      });

    return response;
  }
}
export default new PlanosSemestraisService();
